import React, { useState } from 'react';
import { X } from 'lucide-react';
import api from '../api';

const FindPasswordModal = ({ onClose }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        
        if (value && !validateEmail(value)) {
            setError('올바른 이메일 형식이 아닙니다');
        } else {
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !validateEmail(email)) return;

        try {
            

            const response = await api.post(`/users/password-reset/`, {email});
            setIsSubmitted(true);
        } catch (error) {
            setError('이메일 발송에 실패했습니다. 다시 시도해 주세요.');
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg w-full max-w-md p-6" onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-semibold">
                        {isSubmitted ? '이메일 발송 완료' : '비밀번호 찾기'}
                    </h2>
                    <button
                        onClick={onClose}
                        className="p-1.5 text-gray-500 hover:bg-gray-50 rounded-md transition-colors"
                        title="닫기"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {isSubmitted ? (
                    <div className="text-center py-4">
                        <p className="text-gray-700 mb-6">이메일이 성공적으로 발송되었습니다.</p>
                        <div className="flex gap-2">
                            <button
                                onClick={onClose}
                                className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
                            >
                                확인
                            </button>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <p className="text-gray-600 mb-4">
                            이메일 주소를 입력해 주세요
                        </p>
                        <div className="mb-6">
                            <input
                                type="email"
                                value={email}
                                onChange={handleEmailChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                placeholder="이메일"
                                autoFocus
                            />
                            {error && (
                                <p className="mt-1 text-sm text-red-500">{error}</p>
                            )}
                        </div>
                        <div className="flex gap-2">
                            <button
                                type="button"
                                onClick={onClose}
                                className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors font-medium"
                            >
                                닫기
                            </button>
                            <button
                                type="submit"
                                disabled={!email || !!error}
                                className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed font-medium"
                            >
                                확인
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default FindPasswordModal;